import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import * as moment from 'moment';

import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { FiscalconfigService } from '../fiscalconfig.service';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-fiscalconfig-list',
  templateUrl: './fiscalconfig-list.component.html',
  styleUrls: ['./fiscalconfig-list.component.scss']
})
export class FiscalconfigListComponent implements OnInit {

  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  
  options: GridOptions;
  PageSizes = ["10", "25", "50", "100", "1000", "Todos"];
  selectedSize: string = "25";

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked: (params: any) => this.edit(params),
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    {
      headerName: 'Llave',
      field: 'FiscalKey',
      width: 35,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true
    },
    {
      headerName: 'Valor',
      field: 'FiscalValue',
      width: 25,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true
    },
    {
      headerName: 'Última modificación',
      field: 'ModifiedAt',
      width: 15,
      cellClass: 'align-start',
      sortable: true,
      cellRenderer: (params: any) => params.value ? moment(params.value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    {
      headerName: 'Modificado por',
      field: 'ModifiedBy',
      width: 15,
      cellClass: 'align-start',
      resizable: true
    },
    {
      headerName: 'Editar',
      width: 5,
      cellRenderer: 'childEditRenderer',
      colId: 'params',
      cellClass: 'text-center'
    },
    {
      headerName: 'Eliminar',
      width: 5,
      cellRenderer: 'childDeleteMessageRenderer',
      colId: 'params',
      cellClass: 'text-center'
    }
  ];

  constructor(
    private router: Router,
    private globalFunctionService: GlobalFunctionsService,
    private fiscalConfigService: FiscalconfigService
  ) { }

  ngOnInit(): void { }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getFiscalConfig();
  }
  async refresh(){
    this.getFiscalConfig();
  }

  onPageSizeChange(value: any) {
    if (this.options && this.options.api) {
      this.options.api.paginationSetPageSize(value === 'Todos' ? 999999 : Number(value));
    }
  }

  getFiscalConfig() {
    this.fiscalConfigService.getFiscalConfigList().subscribe(data => {
      if (this.ceqGrid) {
        this.ceqGrid.data = data;
        this.ceqGrid.refreshTable();
      }
    });
  }

  btnAddClick() {
    this.router.navigate(['/tax/fiscalconfig/create']);
  }

  edit(row: any) {
    const id = row.data.IdFiscalConfig;
    this.router.navigate(['/tax/fiscalconfig', id]);
  }

  async delete(row: any) {
    const { FiscalKey, IdFiscalConfig } = row.data;
    const confirm = await this.globalFunctionService.messageBimbo(
      `¿Desea eliminar la configuración "${FiscalKey}"?`, 
      'question1', 
      'Confirmación'
    );

    if (confirm) {
      this.fiscalConfigService.deleteFiscalConfig(IdFiscalConfig).subscribe({
        next: async () => {
          await this.globalFunctionService.messageBimbo('La configuración se eliminó correctamente.', 'success', '¡Éxito!');
          this.getFiscalConfig();
        },
        error: async (err) => {
          const errorMsg = err.error?.message || 'No se pudo eliminar el registro';
          await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
        }
      });
    }
  }
}